/**
 * ObjectListWidget validator
 * @module components/manage/Widgets/ObjectListWidget/validator
 */

import { objectListMessages } from 'govbr.frontend.policy/messages/objectListWidget';
import isObject from 'lodash/isObject';

import { validateObjectFields } from './validatorsNested';

/**
 * Validator for the object_list widget
 * Recursively validates each item in the list of objects
 */
export const objectListWidgetValidator = ({ value, field, formatMessage }) => {
  if (!Array.isArray(value) || !field.schema) return null;

  const errors = value.reduce((acc, item) => {
    const fieldId = item['@id'];
    if (!isObject(item)) return acc;

    const itemErrors = validateObjectFields({
      schema: field.schema,
      data: item,
      formatMessage,
      schemaExtender: field.schemaExtender,
    });

    if (Object.keys(itemErrors).length > 0 && fieldId) {
      acc[fieldId] = itemErrors;
    }
    return acc;
  }, {});

  if (!Object.keys(errors).length) return null;

  const customErrors = [formatMessage(objectListMessages.internalErrors)];
  customErrors.internalErrors = errors;
  return customErrors;
};

export default objectListWidgetValidator;
